// Generated by CoffeeScript 1.12.7
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('views/display_types/single',['require','underscore','models/survey','./display_type','etc/branching_filter','views/components/progress_bar','etc/definitions'],function(require) {
  var BranchingFilter, DisplayType, ProgressBar, Single, Survey, _, audienceStatus;
  _ = require('underscore');
  Survey = require('models/survey');
  DisplayType = require('./display_type');
  BranchingFilter = require('etc/branching_filter');
  ProgressBar = require('views/components/progress_bar');
  audienceStatus = require('etc/definitions').audienceStatus;
  return Single = (function(superClass) {
    extend(Single, superClass);

    function Single() {
      this.participantDisqualifiedHandler = bind(this.participantDisqualifiedHandler, this);
      this.windowResizeHandler = bind(this.windowResizeHandler, this);
      this.submitButtonClickHandler = bind(this.submitButtonClickHandler, this);
      this.previousButtonClickHandler = bind(this.previousButtonClickHandler, this);
      this.nextButtonClickHandler = bind(this.nextButtonClickHandler, this);
      return Single.__super__.constructor.apply(this, arguments);
    }

    Single.prototype.className = 'single';

    Single.prototype.progressBar = null;

    Single.prototype.branchingFilter = null;

    Single.prototype.$html = null;

    Single.prototype.initialize = function(options) {
      return Single.__super__.initialize.call(this, options);
    };

    Single.prototype.render = function() {
      this.initListeners();
      this.$html = $('html');
      if (this.hasBranches) {
        this.participant.set('answers', []);
        this.branchingFilter = new BranchingFilter({
          model: this.model
        });
      }
      this.currentQuestion = this.initQuestion(this.model.get('questions')[0]);
      setTimeout((function(_this) {
        return function() {
          return _this.currentQuestion["in"]({
            animate: true
          });
        };
      })(this), 100);
      this.progressBar = new ProgressBar({
        total: this.model.get('questions').length
      });
      return this.el;
    };

    Single.prototype.next = function(oldQuestion) {
      var answer, index, valid;
      valid = this.recordAnswer(oldQuestion);
      if (valid) {
        index = oldQuestion.index + 1;
        if (this.branchingFilter) {
          answer = this.participant.get('answers')[oldQuestion.index];
          this.branchingFilter.filter(oldQuestion.model.toJSON(), answer);
        }
        oldQuestion.out({
          destroyOnComplete: true
        }, (function(_this) {
          return function() {
            return _this.$html.scrollTop(0);
          };
        })(this));
        if (this.model.get('questions')[index]) {
          this.currentQuestion = this.initQuestion(this.model.get('questions')[index]);
          this.currentQuestion["in"]({
            animate: true
          });
          return this.progressBar.setValue(this.currentQuestion.index + 1, this.model.get('questions').length);
        } else {
          return this.progressBar.destroy((function(_this) {
            return function() {
              return _this.trigger('complete');
            };
          })(this));
        }
      }
    };

    Single.prototype.previous = function(currQuestion) {
      var index, prevQuestion;
      this.recordAnswer(currQuestion);
      index = currQuestion.index - 1;
      prevQuestion = this.model.get('questions')[index];
      currQuestion.out({
        destroyOnComplete: true,
        reverse: true,
        animate: true
      }, (function(_this) {
        return function() {
          return _this.$html.scrollTop(0);
        };
      })(this));
      if (prevQuestion) {
        this.currentQuestion = this.initQuestion(prevQuestion);
        this.currentQuestion["in"]({
          animate: true,
          reverse: true
        });
        return this.progressBar.setValue(this.currentQuestion.index + 1, this.model.get('questions').length);
      }
    };

    Single.prototype.nextButtonClickHandler = function(e, question) {
      e.preventDefault();
      return this.next(question);
    };

    Single.prototype.previousButtonClickHandler = function(e, question) {
      e.preventDefault();
      return this.previous(question);
    };

    Single.prototype.submitButtonClickHandler = function(e, question) {
      e.preventDefault();
      return this.next(question);
    };

    Single.prototype.windowResizeHandler = function(e) {
      if (this.currentQuestion) {
        return this.currentQuestion.center({
          animate: false
        });
      }
    };

    Single.prototype.participantDisqualifiedHandler = function() {
      var audience;
      if (this.participant) {
        this.participant.disqualified = true;
        audience = this.participant.get('audience');
        if (audience && audience.session && audience.session.length) {
          return audience.status = audienceStatus.disqualify;
        }
      }
    };

    Single.prototype.questionUpdateHandler = function(question) {};

    Single.prototype.initListeners = function() {
      $(window).resize(this.windowResizeHandler);
      return this.model.once(Survey.DISQUALIFY_EVENT, this.participantDisqualifiedHandler);
    };

    return Single;

  })(DisplayType);
});

